import { Component, Inject, OnDestroy } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from '@services/notification.service';
import { RecipeService } from '@services/recipe/recipe.service';
import { RecipeLite } from '@shared/models/recipe/recipe-lite.model';

@Component({
  selector: 'app-rework-recipe-popin',
  templateUrl: './rework-recipe-popin.component.html',
  styleUrls: ['./rework-recipe-popin.component.scss'],
  standalone: false,
})
export class ReworkRecipePopinComponent implements OnDestroy {
  private readonly destroy$: Subject<void> = new Subject();

  constructor(
    private dialogRef: MatDialogRef<ReworkRecipePopinComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { variantList: RecipeLite[]; recipeOriginal: RecipeLite },
    public recipeService: RecipeService,
    private notificationService: NotificationService,
    private translateService: TranslateService,
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  submit(): void {
    this.recipeService
      .reworkRecipe(this.data.recipeOriginal.identifier.sourceSystem, this.data.recipeOriginal.topRecipeId)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.notificationService.sendSuccess(this.translateService.instant('RECIPE_REWORK_SUCCESS'));
          this.dialogRef.close(true);
        },
        error: (error) => this.errorManager(error),
      });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  errorManager(err: HttpErrorResponse): void {
    let errorText = null;
    if (err.status && err.status === 403) {
      errorText = this.translateService.instant('RECIPE_REWORK_FORBIDDEN');
      this.notificationService.sendError(errorText);
    } else {
      this.notificationService.sendAPIError(err);
    }
  }
}
